import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { AnswerImage } from 'src/app/common-class/answer-image';

@Component({
  selector: 'app-answer-images',
  templateUrl: './answer-images.component.html',
  styleUrls: ['./answer-images.component.css'],
  //changeDetection: ChangeDetectionStrategy.OnPush
})
export class AnswerImagesComponent implements OnInit {

  @Input() AnswerImages: AnswerImage[];
  constructor() { }

  ngOnInit() {
    //let abc = this.AnswerImages[0].imageName;
   // alert(abc);
  }
  checkimageURL(imageURL,e){
    if(imageURL=="" || imageURL==undefined){
      e.stopPropagation();
    }
  }

}
